/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_EmptyInputs */

const cs_settings_teams_empty = /** @type {(inputs: Settings_Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné týmy`)
};

const en_settings_teams_empty = /** @type {(inputs: Settings_Teams_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No teams yet`)
};

/**
* | output |
* | --- |
* | "No teams yet" |
*
* @param {Settings_Teams_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_empty = /** @type {((inputs?: Settings_Teams_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_empty(inputs)
	return cs_settings_teams_empty(inputs)
});